import React, { FunctionComponent } from 'react';
import { connect, MapStateToProps } from 'react-redux';
import { Typography, Grid, Colors } from '@inplayer-org/inplayer-ui';
import styled from 'styled-components';

// utils
import { ItemDetails } from 'ducks/merchantDucks/items/types';
import RootState from 'ducks/RootState';

// styled components
import { BlueTypography } from 'components/SharedStyledElements';

const { Container, Cell } = Grid;

interface OwnProps {
  assetDetails: ItemDetails;
}

type Props = OwnProps;

const ImageWrapper = styled(Cell)`
  width: 100%;
  height: 110px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    vertical-align: middle;
  }
`;

const FileWrapper = styled(Cell)`
  box-shadow: ${Colors.gray} 0px 0.2rem 0.5rem;
  padding: 0.4rem;
`;

const DlcContent: FunctionComponent<Props> = (props) => {
  const renderFile = (
    file: { filename: string; title: string; file_description: string; thumbnail: string },
    i: number
  ) => {
    const { thumbnail, filename, title, file_description: fileDescription } = file;
    return (
      <FileWrapper width={1} key={i}>
        <Container columns={7}>
          <ImageWrapper width={3} center middle>
            <img alt="preview-img" src={thumbnail} />
          </ImageWrapper>
          <Cell width={4} left={4} middle>
            <Container columns={1}>
              <Cell width={1}>
                <BlueTypography variant="h6">{filename}</BlueTypography>
              </Cell>
              <Cell width={1}>
                <Typography variant="p">{title}</Typography>
              </Cell>
              <Cell width={1}>
                <Typography variant="p">{fileDescription}</Typography>
              </Cell>
            </Container>
          </Cell>
        </Container>
      </FileWrapper>
    );
  };

  const renderEmptyMessage = () => {
    return <Typography variant="p">There are no files added for this asset.</Typography>;
  };

  const { assetDetails } = props;
  const assetContentFiles = JSON.parse(unescape(assetDetails.content));
  const areAddedFiles = assetContentFiles.length !== 0;

  return (
    <Container rowGap="2rem" columns={1}>
      <Cell width={1}>
        <BlueTypography variant="h6">Asset Files</BlueTypography>
      </Cell>
      <Cell width={1}>
        {areAddedFiles ? (
          <Container columns={2} gap="2rem 1.5rem">
            {assetContentFiles.map(renderFile)}
          </Container>
        ) : (
          renderEmptyMessage()
        )}
      </Cell>
    </Container>
  );
};

export const mapStateToProps: MapStateToProps<Props, OwnProps, RootState> = (state) => ({
  assetDetails: state.items.itemDetails,
});

export default connect(mapStateToProps, null)(DlcContent);
